import React, { useMemo } from 'react';
import PageLayout from '../../components/PageLayout';
import GonorarBlock from '../../components/GonorarBlock';

export default function FederationadministratorComissionGonorar(props) {
    const x = useMemo(()=>({ organizatorFederatsiyaID: 1 }),[])
    return (
        <PageLayout>
            <div style={{ padding: "10px" }}>
                <GonorarBlock {...props} source={"/api/shablonisudeiskikhgonorarov/list/fed"}
                    sourceKey="fed"
                    create={true}
                    ctx={x}
                />
            </div>
        </PageLayout>
    );
}
